import React from 'react';
import { Slider } from './slider';

class SliderGroup extends React.Component {
  // todo: allow rendering of multiple sliders at once in a group
  render() {
    return (
      <span className="slider-group">
        <label htmlFor={this.props.name} className="slider-label">
          {this.props.label}
        </label>
        <span className="slider-body">
          <Slider
            min="0"
            className={this.props.className}
            disabled={this.props.disabled}
            max={this.props.max}
            name={this.props.name}
            onChange={this.props.onChange}
            value={this.props.value}
          />
        </span>
      </span>
    );
  }
}

export { SliderGroup };
